import React, { useEffect } from "react";
import * as echarts from "echarts";

interface DepartmentData {
  name: string;
  value: number;
  color: string;
}

interface ChartItem {
  month: string;
  departments: DepartmentData[];
}

interface BarChartProps {
  chartData: ChartItem[];
}

const MoodLineChart = ({ chartData }: any) => {
  useEffect(() => {
    const data = chartData.Avg || [];
    const color = chartData.color || "#DDD";

    console.log(data, "MoodLineChart");

    // Create a bar chart
    const chart = echarts.init(
      document.getElementById("mood-line-chart") as HTMLDivElement
    );

    // Extract department names dynamically
    // const departmentNames =
    //   data[0]?.departments.map((department: any) => department.name) || [];

    // const options = {
    //   xAxis: {
    //     type: "category",
    //     data: data.map((item: ChartItem) => item.month),
    //     axisLabel: {
    //       rotate: 45,
    //     },
    //   },
    //   yAxis: {
    //     type: "value",
    //     min: 1,
    //     max: 8, // Set the maximum value of the y-axis as needed
    //     interval: 1,
    //   },
    //   series: departmentNames.map((department: any) => ({
    //     name: department,
    //     type: "bar",
    //     data: data.map((item: ChartItem) => {
    //       const depData = item.departments.find(
    //         (dep) => dep.name === department
    //       );
    //       return depData ? depData.value : 0;
    //     }),
    //     itemStyle: {
    //       color: (item: any) => {
    //         const depData = data
    //           .find((d: any) => d.month === item.name)
    //           ?.departments.find((dep: any) => dep.name === department);
    //         return depData ? depData.color : "#000000"; // Default color if no color is found
    //       },
    //     },
    //   })),
    // };
    const seriesData = data?.map((item: any) => item?.avg);

    const options = {
      grid: {
        left: "5%",
        right: "5%",
        bottom: "2%",
        containLabel: true,
      },
      xAxis: {
        type: "category",
        boundaryGap: false,
        data: data?.map((item: any) => item.day),
      },
      yAxis: {
        type: "value",
        min: 0,
        max: 3,
        interval: 1,
      },
      series: [
        {
          data: seriesData,
          type: "line",
          areaStyle: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              { offset: 0, color: hexToRGBA(color, 0.5) }, // Dynamic top gradient color
              { offset: 1, color: hexToRGBA(color, 0) }, // Dynamic bottom gradient color
            ]),
          },
          lineStyle: {
            color: "#EB228A", // Line color
            width: 2, // Line width
          },
        },
      ],
    };

    function hexToRGBA(hex: string, alpha: number) {
      let r = 0,
        g = 0,
        b = 0;

      if (hex.startsWith("#")) {
        if (hex.length === 7) {
          r = parseInt(hex.slice(1, 3), 16);
          g = parseInt(hex.slice(3, 5), 16);
          b = parseInt(hex.slice(5, 7), 16);
        } else if (hex.length === 4) {
          r = parseInt(hex[1] + hex[1], 16);
          g = parseInt(hex[2] + hex[2], 16);
          b = parseInt(hex[3] + hex[3], 16);
        }
      }

      return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    }

    // Set chart options
    chart.setOption(options);

    // Cleanup on unmount
    return () => {
      chart.dispose();
    };
  }, [chartData]);

  return (
    <div
      id="mood-line-chart"
      style={{
        width: "100%",
        height: "400px",
        margin: "0 !important",
        cursor: "not-allowed !important",
      }}
    ></div>
  );
};

export default MoodLineChart;
